import React, { useState, useEffect } from 'react';

const AdZone = ({ placementId, className = "", fallback = null, style = {} }) => {
  const [adContent, setAdContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchAdContent();
  }, [placementId]);

  const fetchAdContent = async () => {
    try {
      const response = await fetch(`${API}/api/public/ad/${placementId}`);
      if (response.ok) {
        const adData = await response.json();
        
        console.log(`Ad data for ${placementId}:`, adData);
        
        if (adData && !adData.error) {
          setAdContent(adData);
        }
      }
    } catch (error) {
      console.error(`Error fetching ad for ${placementId}:`, error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdClick = async (adId) => {
    try {
      await fetch(`${API}/api/ads/${adId}/click`, { method: 'POST' });
    } catch (error) {
      console.error('Error tracking ad click:', error);
    }
  };

  if (loading) {
    return (
      <div className={`ad-zone-loading ${className}`}>
        <div className="animate-pulse bg-gray-700 h-full w-full rounded"></div>
      </div>
    );
  }

  if (!adContent) {
    return fallback || null;
  }

  return (
    <div 
      className={`ad-zone ${className}`}
      style={style}
      onClick={() => handleAdClick(adContent.id)}
    >
      {adContent.iframe_code && (
        <div dangerouslySetInnerHTML={{ __html: adContent.iframe_code }} />
      )}
      {adContent.native_code && (
        <div dangerouslySetInnerHTML={{ __html: adContent.native_code }} />
      )}
    </div>
  );
};

export default AdZone;